import { Badge, type Tone } from "../ui";

const STATUS_WORD_TONES = {
  activo: "primary",
  disponible: "primary",
  concedido: "primary",
  pagado: "primary",
  confirmada: "primary",
  confirmado: "primary",
  reservado: "primary",
  usada: "primary",
  vigente: "primary",
  online: "primary",
  completado: "primary",
  aprobado: "primary",
  entrada: "primary",
  abierta: "primary",
  abierto: "primary",
  ganador: "primary",
  adjudicada: "primary",
  aceptada: "primary",
  aceptado: "primary",
  "en contacto": "primary",

  pendiente: "warning",
  mantenimiento: "warning",
  salida: "warning",
  "por vencer": "warning",
  "en proceso": "warning",
  parcial: "warning",
  "por cerrar": "warning",
  "en puja": "warning",
  contraoferta: "warning",
  "en revisión": "warning",
  reservando: "warning",

  inactivo: "error",
  denegado: "error",
  expirada: "error",
  vencido: "error",
  cancelada: "error",
  cancelado: "error",
  offline: "error",
  rechazado: "error",
  bloqueado: "error",
  agotado: "error",
  "sin espacio": "error",
  "no participa": "error",
  "cerrada sin pujas": "error",
} as const satisfies Record<string, Tone>;

const TONE_LOOKUP: Record<string, Tone> = STATUS_WORD_TONES;

export function StatusTextBadge({ value }: { value: unknown }) {
  const text = String(value ?? "");
  if (!text) return <span className="text-content-faint">—</span>;
  return (
    <Badge tone={TONE_LOOKUP[text.trim().toLowerCase()] ?? "info"} className="whitespace-nowrap">
      {text}
    </Badge>
  );
}
